function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.3309 0.0171374C27.0346 -0.371249 33.4285 5.89582 35.4812 13.3312C37.2856 19.867 33.258 26.2245 27.5957 29.9542C22.7301 33.1592 16.4634 32.4359 11.8197 28.917C7.4685 25.6198 6.14602 20.0247 7.51931 14.7409C9.26915 8.00829 12.3835 0.367397 19.3309 0.0171374Z",
  fill: "#4F71E0",
  fillOpacity: 0.08
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.0303 4.33337C7.60318 4.33337 2.39401 9.54254 2.39401 15.9697C2.39401 21.11 5.72718 25.4722 10.3518 27.0122C10.934 27.1172 11.144 26.759 11.144 26.451C11.144 26.1745 11.1347 25.4419 11.1312 24.4724C7.89368 25.1747 7.21001 22.9114 7.21001 22.9114C6.68268 21.5674 5.91851 21.2092 5.91851 21.2092C4.86268 20.487 5.99901 20.5034 5.99901 20.5034C7.16801 20.585 7.78051 21.7027 7.78051 21.7027C8.81885 23.4807 10.5058 22.9674 11.1662 22.6699C11.2723 21.9174 11.5757 21.404 11.907 21.1135C9.32401 20.8207 6.60801 19.822 6.60801 15.3619C6.60801 14.0937 7.06185 13.053 7.80268 12.241C7.68485 11.9459 7.28235 10.7617 7.91818 9.16104C7.91818 9.16104 8.89468 8.84721 11.1172 10.3522C12.0664 10.094 13.0455 9.96218 14.0292 9.96021C15.0129 9.9618 15.9921 10.0936 16.9412 10.3522C19.1648 8.84604 20.1402 9.16104 20.1402 9.16104C20.776 10.7617 20.377 11.9459 20.2557 12.241C21.0023 13.053 21.4503 14.0925 21.4503 15.3619C21.4503 19.8337 18.732 20.816 16.1397 21.1042C16.5538 21.4635 16.9272 22.1729 16.9272 23.2579C16.9272 24.8142 16.9132 26.0695 16.9132 26.451C16.9132 26.7625 17.1208 27.1242 17.7147 27.0099C22.337 25.4675 25.6667 21.1089 25.6667 15.9697C25.6667 9.54254 20.4575 4.33337 14.0303 4.33337Z",
  fill: "#060238"
});

var SvgGithub = function SvgGithub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/github.e96cc41e.svg";
export { ForwardRef as ReactComponent };